import { FullPageLoader } from "@/components/FullPageLoader";
import { Navigate } from "react-router-dom";
import { useRole } from "@/contexts/RoleContext";

interface RoleRestrictedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
}

export function RoleRestrictedRoute({ 
  children, 
  allowedRoles, 
  redirectTo = "/learning/dashboard" 
}: RoleRestrictedRouteProps) {
  const { userRole, isLoading } = useRole();

  if (isLoading) {
    return <FullPageLoader message="Loading..." />;
  }

  // If user has a role that's not allowed, redirect them
  if (userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
